import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../components/PageHeader';

function About() {
	return (
		<>
			<Helmet>
				<title>About • Appex Connect Hub</title>
			</Helmet>
			<PageHeader
				title="About APEX SPECIALTY CONTRACTING LLC"
				subtitle="Construction-first specialty contracting with compliant, transparent communications."
			/>
			<section className="section">
				<div className="container two-col">
					<div>
						<h2>Who We Are</h2>
						<p className="helper">
							We are specialty contractors who pair strong field execution with clear, compliant communication.
							We are not a lender and do not make credit decisions.
						</p>
						<div className="grid" style={{ marginTop: 14 }}>
							<div className="card" style={{ padding: 18 }}>
								<div className="icon-circle">
									<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 19h16M7 11l2-6h6l2 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
								</div>
								<h3>Construction Roots</h3>
								<p className="helper">Specialty contracting expertise with predictable timelines and scope clarity.</p>
							</div>
							<div className="card" style={{ padding: 18 }}>
								<div className="icon-circle">
									<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 7h12v10H6V7Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9 10h6m-6 3h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
								</div>
								<h3>Transparent Processes</h3>
								<p className="helper">Plain-language scopes, opt-in updates, and prompt responses to changes.</p>
							</div>
							<div className="card" style={{ padding: 18 }}>
								<div className="icon-circle">
									<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2 3 7l9 5 9-5-9-5Z" stroke="currentColor" strokeWidth="1.5"/><path d="M5 10v6l7 4 7-4v-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
								</div>
								<h3>Reliable Partnerships</h3>
								<p className="helper">Vetted teams, safety focus, and compliance evidence for every engagement.</p>
							</div>
						</div>
					</div>
					<div className="img-frame fade-up">
						<img src="https://images.unsplash.com/photo-1503389152951-9f343605f61e?q=80&w=1600&auto=format&fit=crop" alt="Construction team at work" />
					</div>
				</div>
			</section>
			<section className="section">
				<div className="container">
					<div className="card" style={{ padding: 18, marginBottom: 12 }}>
						<strong>Business Address</strong>
						<p className="helper">183 Highland Rd, Tarpon Springs, FL 34689</p>
					</div>
					<div className="card" style={{ padding: 18 }}>
						<strong>Contact</strong>
						<p className="helper">Email: <a href="mailto:info@appexconnecthub.com">info@appexconnecthub.com</a> • Support: <a href="mailto:support@appexconnecthub.com">support@appexconnecthub.com</a></p>
					</div>
				</div>
			</section>
		</>
	);
}

export default About;


